import { client } from '../apiClient';
import { CloudflareTestResponse } from '../../types/bot-sources/CloudflareTestResponse';
import { CloudflareConnectResponse } from '../../types/bot-sources/CloudflareConnectResponse';
import { CloudflareStatusResponse } from '../../types/bot-sources/CloudflareStatusResponse';

const CLOUDFLARE_ENDPOINT = '/bot-sources/cloudflare';

export const testCloudflareConnection = async (
  apiToken: string
): Promise<CloudflareTestResponse> => {
  const { data } = await client(true, true).post<CloudflareTestResponse>(
    `${CLOUDFLARE_ENDPOINT}/test`,
    { apiToken }
  );
  return data;
};

export const connectCloudflare = async (
  projectId: number,
  apiToken: string,
  zoneId: string
): Promise<CloudflareConnectResponse> => {
  const { data } = await client(true, true).post<CloudflareConnectResponse>(
    `${CLOUDFLARE_ENDPOINT}/connect`,
    { projectId, apiToken, zoneId }
  );
  return data;
};

export const disconnectCloudflare = async (projectId: number, integrationId: number): Promise<void> => {
  await client(true, true).post(`${CLOUDFLARE_ENDPOINT}/disconnect`, { projectId, integrationId });
};

export const getCloudflareStatus = async (
  projectId: number
): Promise<CloudflareStatusResponse> => {
  const { data } = await client(true, true).get<CloudflareStatusResponse>(
    `${CLOUDFLARE_ENDPOINT}/status`,
    { params: { projectId } }
  );
  return data;
};
